import React from 'react'
import './Loader.scss'

export default function Loader() {
    return (
        <div className="loader-container">
            <div className="loader"></div>
        </div>
    )
}
